export const OSCE_REQUEST_START = 'OSCE_REQUEST_START';
export const FETCH_OSCE_RESULTS_SUCCESS = 'FETCH_OSCE_RESULTS_SUCCESS';
export const FETCH_OSCE_RESULTS_ERROR = 'FETCH_OSCE_RESULTS_ERROR';
export const LOAD_MORE_RESULTS_SUCCESS = 'LOAD_MORE_RESULTS_SUCCESS';
export const FETCH_OSCE_BELL_SYSTEM_SUCCESS = 'FETCH_OSCE_BELL_SYSTEM_SUCCESS';
export const FETCH_OSCE_BELL_SYSTEM_ERROR = 'FETCH_OSCE_BELL_SYSTEM_ERROR';
export const UPDATE_OSCE_BELL_SYSTEM_SUCCESS =
  'UPDATE_OSCE_BELL_SYSTEM_SUCCESS';
export const UPDATE_OSCE_BELL_SYSTEM_ERROR = 'UPDATE_OSCE_BELL_SYSTEM_ERROR';
